import { pr, React, theme, ui } from "aaa";
import { CSSProperties } from "react";
import { IAccount } from "types/account";
import { amountToCurrencyString, amountToNumber } from "types/amount";

type IAccountVariant = "account" | "loan";

const getAliasOrDescription = (account: IAccount | undefined, variant: IAccountVariant) => {
    if (account) {
        if (variant === "account") {
            return account.description;
        } else if (variant === "loan") {
            return account.alias || account.description;
        }
    }

    return "?";
};

const getFormattedAmount = (account: IAccount | undefined, variant: IAccountVariant) => {
    if (account) {
        const disposableAmount = amountToCurrencyString(account.disposable);

        if (variant === "account") {
            return disposableAmount;
        } else if (variant === "loan") {
            if (account.loan?.nextRateAmount) {
                return amountToCurrencyString(account.loan?.nextRateAmount);
            }
        }
    }

    return "?";
};

export const Account = ({ variant = "account", ...props }: {
    account?: IAccount;
    style?: {};
    checked?: boolean;
    separator?: boolean;
    onSelectAccount?: (account: IAccount) => void;
    useCheckBoxes?: boolean;
    variant?: IAccountVariant;
}) => {
    const [focus, setFocus] = React.useState(false);

    // Positive balance: green, negative: red
    const balanceColor = (
        props.account
        && props.account.balance
        && amountToNumber(props.account.balance) >= 0
    ) ? "#00b356" : "#cc0000";

    const onClick = () => {
        if (props.onSelectAccount && props.account) {
            return props.onSelectAccount(props.account);
        }
    };

    return (
        <div
            style={{ position: "relative", outline: "none", boxShadow: focus ? theme.focusShadow : "none", cursor: props.onSelectAccount ? "pointer" : undefined }}
            onClick={onClick}
            onKeyUp={(e) => {
                if (e.keyCode === 13 || e.keyCode === 32) {
                    onClick();
                }
            }}
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
            role={props.useCheckBoxes ? "checkbox" : "button"}
            tabIndex={props.onSelectAccount ? 0 : -1}
            aria-checked={!props.useCheckBoxes ? undefined : props.checked ? "true" : "false"}
        >
            <pr.HFlexCentered style={props.style}>
                {props.useCheckBoxes === true &&
                    <div style={{ transform: "scale(1.2)", marginRight: 10, alignSelf: "flex-start" }}>
                        {props.checked && <pr.IconCheckbox style={{ fill: theme.customColors.georgeLightBlue }} />}
                        {!props.checked && <pr.IconCheckboxOutline style={{ fill: "#B8C4D1" }} />}
                    </div>
                }
                <div style={{ flex: 1 }}>
                    <pr.P_16_CONTENT>{getAliasOrDescription(props.account, variant)}</pr.P_16_CONTENT>
                    <pr.P_16_CONTENT style={{ color: balanceColor }}>
                        {props.account ? amountToCurrencyString(props.account.balance) : "?"}
                    </pr.P_16_CONTENT>
                    <pr.P_12_CONTENT>
                        {variant === "loan" && ui.__("account.rateAmount")}
                        {variant === "account" && ui.__("account.disposable")}
                        {" "}
                        {getFormattedAmount(props.account, variant)}
                    </pr.P_12_CONTENT>
                    <pr.P_12_CONTENT>
                        {ui.__("account.iban") + " " + (props.account ? props.account.accountno.iban : "?")}
                    </pr.P_12_CONTENT>
                </div>
                {!props.useCheckBoxes && props.checked &&
                    <div role="button" aria-label={ui.__("a11y.selected")}>
                        <pr.IconCheck style={{ color: theme.customColors.georgeLightBlue }} />
                    </div>
                }
            </pr.HFlexCentered>
            {props.separator && <pr.LightSeparatorLine />}
        </div>
    );
};

export const AccountShort = (props: { account?: IAccount, style?: CSSProperties }) => (
    <div style={props.style}>
        <pr.P_16_TITLE>{props.account ? props.account.productI18N : "?"}</pr.P_16_TITLE>
        <pr.P_16_TITLE>{props.account ? props.account.accountno.iban : "?"}</pr.P_16_TITLE>
    </div>
);



// WEBPACK FOOTER //
// ./src/components/common/Account.tsx